const cdn_india_staging='';
const cdn_india_prod='https://d2vru07t39huna.cloudfront.net/';
const cdn_uae_staging='';
const cdn_uae_prod='https://d6v1vv9qi2pei.cloudfront.net/';

module.exports = { cdn_india_staging, cdn_india_prod, cdn_uae_staging, cdn_uae_prod }
